import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./Card.css";
import { importAllImages } from "./CardsImage";

const Card = () => {
  const [lightboxData, setLightboxData] = useState({
    category: null,
    slides: [],
  });

  const openLightbox = (category, keyword) => {
    const slides = getSlides(keyword);
    setLightboxData({ category, slides });
  };

  const closeLightbox = () => {
    setLightboxData({ category: null, slides: [] });
  };

  const images = importAllImages(
    require.context("../../../assets/ProgramCenter", true, /\.(png|jpe?g|svg)$/)
  );

  const getSlides = (keyword) =>
    Object.entries(images)
      .filter(([path]) =>
        path.toLowerCase().startsWith(`${keyword.toLowerCase()}/`)
      )
      .map(([_, src], i) => ({
        src,
        caption: `${keyword} - Image ${i + 1}`,
      }));

  const imageData = [
    { category: "oahuYurts", name: "Oahu Yurts", keyword: "Oahu" },
    { category: "hawaiiYurts", name: "Hawaii Yurts", keyword: "Hawaii" },
    { category: "mauiYurts", name: "Maui Yurts", keyword: "Maui" },
    { category: "lanaiYurts", name: "Lanai Yurts", keyword: "Lanai" },
    { category: "molokaiCabin", name: "Molokai Cabin", keyword: "Molokai" },
    {
      category: "kahoolaweCabin",
      name: "Kahoolawe Cabin",
      keyword: "Kahoolawe",
    },
    { category: "hale", name: "Multi Purpose Center (HALE)", keyword: "Hale" },
    { category: "programArea", name: "Program Area", keyword: "LandProgram" },
  ];

  return (
    <div className="Gallery-Component">
      <h1 className="Gallery-Heading">Program Center</h1>
      <div className="Cards-div">
        {imageData.map((data, index) => (
          <div
            key={index}
            className="Card"
            onClick={() => openLightbox(data.category, data.keyword)}
          >
            <div className="Image"></div>
            <h3 className="Cards-Heading">{data.name}</h3>
          </div>
        ))}
      </div>

      {/* 🔥 Single, globally controlled Lightbox instance */}
      <Lightbox
        open={!!lightboxData.category}
        close={closeLightbox}
        slides={lightboxData.slides}
      />
    </div>
  );
};

export default Card;
